module.exports = __webpack_public_path__ + "static/media/rewardzlogo.71815172.svg";